// export const baseUrl = "http://localhost:5000/api";
// export const imgBaseUrl = "http://localhost:5000";
export const baseUrl = "https://api.solebs.com/api";
export const imgBaseUrl = "https://api.solebs.com";
